import Icon from '@components/Icon/Icon';
import type { CardUrlType } from 'types';

import styles from './Field.module.scss';

interface UrlFieldProps {
  type: CardUrlType;
  title?: string;
  size?: 'regular' | 'small' | 'extra-small';
  /** Will default to true. If false, no UI changes upon interaction. */
  interactive?: boolean;
}

const UrlField: React.FC<React.PropsWithChildren<UrlFieldProps>> = ({
  type,
  title,
  size,
  interactive = true,
}) => {
  return (
    <div className={styles['card-field']} data-size={size}>
      {/* I add a key to icon if we are in a URL field because otherwise the icon will not rerender when
            you change the type. I don't know why this is, this bug has taken a small part of my soul. */}
      <div
        className={styles['card-item-icon-circle']}
        key={type}
        data-is-interactive={interactive}
        data-size={size}
      >
        <Icon type={type} className={styles['field-icon']} />
      </div>
      <div className={styles['field-data']}>
        {title && (
          <div className={styles['field-data-value']} data-type="url">
            {title}
          </div>
        )}
        {!title && <div className={styles['field-data-value-placeholder']}>Title</div>}
      </div>
    </div>
  );
};

export default UrlField;
